import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import ADMIN_API_URL from "../../../config/AdminApiUrl";

export const getEmailPlaceholderList = createAsyncThunk(
  "EmailPlaceholder/get",
  async (tenantId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${ADMIN_API_URL.EMAIL_PLACEHOLDER.LIST}/${tenantId}`
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createEmailPlaceholder = createAsyncThunk(
  "EmailPlaceholder/create",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(
        `${ADMIN_API_URL.EMAIL_PLACEHOLDER.SLUG}`,
        payload
      );
      dispatch(getEmailPlaceholderList(payload?.emailTemplateId));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const editEmailPlaceholder = createAsyncThunk(
  "EmailPlaceholder/put",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(
        `${ADMIN_API_URL.EMAIL_PLACEHOLDER.SLUG}`,
        payload
      );
      dispatch(getEmailPlaceholderList(payload?.emailTemplateId));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const getEmailPlaceholderDetails = createAsyncThunk(
  "EmailPlaceholderDetail/get",
  async (Id, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${ADMIN_API_URL.EMAIL_PLACEHOLDER.SLUG}/${Id}`
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const emailPlaceholderSlice = createSlice({
  name: "emailPlaceholder",
  initialState: {
    current_placeholder_values: null,
    email_placeholder_list: [],
    email_placeholder_details: {},
  },
  reducers: {
    setPlaceholderCurrentValues(state, action) {
      state.current_placeholder_values = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEmailPlaceholderList.fulfilled, (state, action) => {
        state.email_placeholder_list = action.payload;
      })
      .addCase(getEmailPlaceholderDetails.fulfilled, (state, action) => {
        state.email_placeholder_details = action.payload;
      });
  },
});

export const {
  setPlaceholderCurrentValues,
  setActivePayload,
  resetCurrentValue,
} = emailPlaceholderSlice.actions;
export default emailPlaceholderSlice.reducer;
